import Navbar from "../components/Navbar";
import data from "../language.json";
import React, { useContext, useState } from "react";
import languageContext from "../context/language/languageContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { PlusCircle, Trash2 } from "lucide-react"; // optional: lucide icons for nice add/remove
import {API_URL,FAST_API_URL} from "../api"
const Profile = () => {
  const { lang } = useContext(languageContext);
  const navigate = useNavigate();

  const [details, setDetails] = useState({
    patient_name: "",
    abha_id: "",
    doctor_name: "",
    doctor_number: "",
    hospital_name: "",
    hospital_number: "",
    caregiver_number: "",
    caregiver_name: "",
    relation_of_patient: "",
    doctors: [{ name: "", number: "" }],
    chemists: [{ name: "", number: "" }],
    labs: [{ name: "", number: "" }],
    hospitals: [{ name: "", number: "" }],
  });

  const handleChange = (e, field) => {
    setDetails((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const addNewItem = (listName) => {
    setDetails((prev) => ({
      ...prev,
      [listName]: [...(prev[listName] || []), { name: "", number: "" }],
    }));
  };

  const removeItem = (listName, index) => {
    const updatedList = [...details[listName]];
    updatedList.splice(index, 1);
    setDetails((prev) => ({ ...prev, [listName]: updatedList }));
  };

  const handleListChange = (e, index, listName, field) => {
    const newList = [...details[listName]];
    newList[index][field] = e.target.value;
    setDetails((prev) => ({ ...prev, [listName]: newList }));
  };

  const submitProfile = async () => {
    try {
      const headerList = {
        Accept: "*/*",
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      };
      await axios.post(
        `${API_URL}/sigup_details`,
        { details },
        { headers: headerList }
      );
      navigate("/ask");
    } catch (error) {
      console.error("Error saving details:", error);
      alert("Could not save your data, please try again later");
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-sky-50 to-blue-100">
      <Navbar />
      <div className="max-w-5xl mx-auto p-8 mt-10 bg-white rounded-2xl shadow-xl">
        <h2 className="text-3xl font-bold text-center text-blue-800 mb-8">
          {data[lang]["Profile Heading"]}
        </h2>

        {/* Static Profile Fields */}
        {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {data[lang]["profile"].map((item, index) => (
            <div key={index} className="flex flex-col">
              <label className="text-gray-800 font-semibold">{item.name}</label>
              <input
                type="text"
                required
                className="mt-2 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                value={details[item.value]}
                onChange={(e) => handleChange(e, item.value)}
                placeholder={`Enter ${item.name}`}
              />
            </div>
          ))}
        </div> */}

        

        {/* Helper to render repeatable sections */}
        {[
          { title: "Doctors", key: "doctors" },
          { title: "Chemists", key: "chemists" },
          { title: "Labs", key: "labs" },
          { title: "Hospitals", key: "hospitals" },
        ].map(({ title, key }) => (
          <div key={key} className="mb-10">
            <h3 className="text-2xl font-bold mb-4 text-blue-700">{title}</h3>
            {details[key]?.map((item, index) => (
              <div
                key={index}
                className="relative border border-gray-200 bg-gray-50 p-4 rounded-lg shadow mb-4"
              >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="flex flex-col">
                    <label className="text-gray-800 font-medium">
                      {title.slice(0, -1)} Name
                    </label>
                    <input
                      type="text"
                      className="mt-2 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                      value={item.name}
                      placeholder={`Enter ${title.slice(0, -1)} Name`}
                      onChange={(e) =>
                        handleListChange(e, index, key, "name")
                      }
                    />
                  </div>
                  <div className="flex flex-col">
                    <label className="text-gray-800 font-medium">
                      {title.slice(0, -1)} Number
                    </label>
                    <input
                      type="text"
                      className="mt-2 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                      value={item.number}
                      placeholder={`Enter ${title.slice(0, -1)} Number`}
                      onChange={(e) =>
                        handleListChange(e, index, key, "number")
                      }
                    />
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() => removeItem(key, index)}
                  className="absolute top-4 right-4 text-red-500 hover:text-red-700"
                >
                  <Trash2 className="w-5 h-5" />
                </button>
              </div>
            ))}
            <button
              type="button"
              onClick={() => addNewItem(key)}
              className="flex items-center bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg shadow transition"
            >
              <PlusCircle className="w-5 h-5 mr-2" />
              Add Another {title.slice(0, -1)}
            </button>
          </div>
        ))}
        {/* Emergency Contacts */}
        <h3 className="text-2xl font-bold mt-10 mb-4 text-blue-700">
          {data[lang]["Emergency Heading"]}
        </h3>
        {data[lang]["Emergency"].map((emergency, index) => (
          <div
            key={index}
            className="bg-gray-50 border border-gray-200 p-6 rounded-lg shadow mb-6"
          >
            <h4 className="text-xl font-semibold mb-4 text-gray-700">
              {emergency.name}
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {emergency.fields.map((field, idx) => (
                <div key={idx} className="flex flex-col">
                  <label className="text-gray-800 font-medium">
                    {field.name}
                  </label>
                  <input
                    type="text"
                    required
                    className="mt-2 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    value={details[field.value]}
                    onChange={(e) => handleChange(e, field.value)}
                    placeholder={`Enter ${field.name}`}
                  />
                </div>
              ))}
            </div>
          </div>
        ))}


        {/* Submit */}
        <div className="text-center mt-12">
          <button
            type="button"
            onClick={submitProfile}
            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-full shadow-lg transition"
          >
            Save & Proceed
          </button>
        </div>
      </div>
    </div>
  );
};

export default Profile;
